module.exports = __webpack_public_path__ + "static/media/avaya.c1f976e9.png";